import { createFileRoute } from '@tanstack/react-router';
import { EmailWorkspace } from '@/components/email-generation/EmailWorkspace';
import { useSyncTenantFromParams } from '@/context/organization-context';

export const Route = createFileRoute(
  '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit',
)({
  component: EditorPage,
});

function EditorPage() {
  const { orgId, clientId, templateId } = Route.useParams();
  useSyncTenantFromParams(orgId, clientId);
  return <EmailWorkspace templateId={templateId} currentRoute="edit" />;
}
